export enum WithdrawMethodEnum {
  Crypto = 'crypto',
  CryptoApp = 'crypto-app',
  BankTransfer = 'bank-transfer',
  WireTransfer = 'wire-transfer',
}

export type WithdrawMethod = `${WithdrawMethodEnum}`;

export interface WithdrawMethodOption {
  id: WithdrawMethod;
  title: string;
  description: string;
  icon: React.ReactNode;
  badge?: string;
  badgeVariant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'destructive';
  time?: string;
  fee?: string;
  balance?: string;
}
